<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">{{ currentNews.date }}</p>
    <div class="content" :class="langStore.currentLang.startsWith('zh') ? 'lang-zh' : 'lang-en'">
      <template v-for="(p, index) in paragraphs" :key="index">
        <!-- 文字内容 -->
        <div class="content-section">
          <div class="text-block">
            <p :class="{ 'link-paragraph': isLinkParagraph(p) }" v-html="highlightText(p)"></p>
          </div>
        </div>

        <!-- 在特定段落后插入图片 -->
        <div v-if="index === 2" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture1?.url">
          </div>
        </div>
        <div v-else-if="index === 5" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture2?.url">
          </div>
        </div>
        <div v-else-if="index === 8" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture3?.url">
          </div>
        </div>
        <div v-else-if="index === 11" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture4?.url">
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  return newsList.find((news: any) => news.id === 'tisco-cooperation') || {};
});

const paragraphs = computed(() => {
  return currentNews.value.content?.split('---') || [];
});

const highlightText = (text: string) => {
  return text.replace(/\[\[highlight\]\](.*?)\[\[\/highlight\]\]/g, '<span class="highlighted-text">$1</span>');
};

const isLinkParagraph = (text: string) => {
  const normalized = text.trimStart();
  return normalized.startsWith('链接：') || normalized.startsWith('链接:');
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
  font-family: 'Microsoft YaHei', Arial, 'PingFang SC', sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
  text-align: center;
}

.content-section {
  margin-bottom: 20px;
}

/* 中文正文首行缩进 2 个汉字位 */
.content.lang-zh .text-block p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 2em;
}

/* 英文正文不缩进 */
.content.lang-en .text-block p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 0;
}

.text-block p.link-paragraph {
  text-align: left;
  text-indent: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* 小标题蓝色 */
.text-block :deep(h3),
:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  margin-top: 24px;
  margin-bottom: 12px;
}

/* 链接蓝色可点击 */
.text-block :deep(a) {
  color: #1677ff;
  text-decoration: underline;
  overflow-wrap: anywhere;
  word-break: break-all;
  cursor: pointer;
}

.text-block :deep(a:hover) {
  color: #0958d9;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
  max-width: 800px;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

:deep(.highlighted-text) {
  color: #0066cc;
  font-weight: bold;
  background-color: transparent;
  padding: 2px 4px;
  border-radius: 3px;
  display: block;
  margin-top: 15px;
  font-size: 1.1em;
}
</style>
